<template>
	<transition name="slide">
		<div id="pane-report" class="pane pane-report report" v-if="app.view == 'report_B'" :class="{vi : app.aide_live}">
			<div v-show="choix_report" class="dropdown">
				<table>
					<th><td></td></th>
					<tr>
						<td colspan="2" style="text-align: center;">
							<button type="submit" class="buttonv" @click="get_pdf();">
								<span v-show="!app.loading">{{ $t('imprimer_en_pdf') }}</span>
							</button>
						</td>
					</tr>
				</table>				
			</div>
			
			<div class="infinite-loader" v-if="app.loading_calc">
				<div class="loader"><icon file="loader" :size="128" /></div>
			</div>
			
			<div class="header" v-else>
				<div class="header_module">
					<ul class="surface-card p-2 m-0 list-none flex overflow-x-auto select-none" >
						<li class="pr-3"  @click="scrollToElement2('tabprogrammes')">
							<a v-ripple class="cursor-pointer px-4 py-3 flex align-items-center hover:surface-100 border-round transition-colors transition-duration-150 p-ripple"  :class="{'bg-primary hover:bg-primary': ((activeSection === 'tabprogrammes' || activeSection === 'tabheatmapprix' || activeSection === 'tabsynoptique' || activeSection === 'tabsynoptiquepc') && app.livedata.synoptique.length), 'text-700': !((activeSection === 'tabprogrammes' || activeSection === 'tabheatmapprix' || activeSection === 'tabsynoptique' || activeSection === 'tabsynoptiquepc') && app.livedata.synoptique.length)}">
								<i class="pi pi-building mr-2"></i>
								<span class="font-medium">{{ $t('neuf') }}</span>
							</a>
						</li>
						<li class="flex align-items-center">
							<div style="width:1px; height: 50%" class="border-right-1 surface-border"></div>
						</li>
						<li class="px-3" v-if ="app.mrk.lat && app.ModuleAdresse" @click="app.mrk.lat ? scrollToElement2('tabAdresse') : $store.dispatch('add_notification', { status: 'error', message: messagewarning }) ">
							<a v-ripple class="cursor-pointer px-4 py-3 flex align-items-center hover:surface-100 border-round transition-colors transition-duration-150v"  :class="{'bg-primary hover:bg-primary': activeSection === 'tabAdresse', 'text-700': activeSection != 'tabAdresse'}">
								<i class="pi pi-map-marker mr-2"></i>
								<span class="font-medium">{{ $t('qualite_de_ladresse') }}</span>
							</a>
						</li>
						<li class="px-3" v-else @click="clickancien();" @mouseover="showMessage2 = true" @mouseout="showMessage2 = false">
							<a v-ripple class="cursor-pointer px-4 py-3 flex align-items-center surface-100 border-round transition-colors transition-duration-150v"  :class="{'bg-primary hover:bg-primary': activeSection === 'tabAdresse', 'text-700': activeSection != 'tabAdresse'}">
								<i class="pi pi-map-marker mr-2"></i>
								<span class="font-medium">{{ $t('qualite_de_ladresse') }}</span>
							</a>
						</li>
					</ul>	
					
				</div>
				<div class="toreport">
					<Button icon="pi pi-map" v-if="!app.loading" :label="$t('Retour cartographie')" class="p-button-rounded p-button-success" @click="set_back();$store.dispatch('set_help_live', {aide:false})" />
					<Button icon="pi pi-map" v-else :label="$t('Retour cartographie')" class="p-button-rounded p-button-success" disabled="disabled" />
				</div>
				
			</div>
			
			<div class="download_div_big" v-if="app.report_dispo">
				<div class="download_div">
					<div class="print-button"><a :href="app.url_report" target="_blank" download="Rapport.pdf"  @click="set_report()"><icon file="download" :size="96" /></a></div>
				</div>
			</div>
			<div style="height:60px;width:100%;background: #f8f9fa !important; border-bottom: #ccc solid 1px;" class="header_module">
				<div style="display: flex; width:calc(100% - 240px);" v-if="(activeSection === 'tabprogrammes' || activeSection === 'tabheatmapprix' || activeSection === 'tabsynoptique' || activeSection === 'tabsynoptiquepc') && app.livedata.synoptique.length">
					<div class="module_theme2" :class="{ active: activeSection === 'tabprogrammes' }">
						<span v-if="app.livedata.volume_periode_1" class="module_titre" @click="scrollToElement2('tabprogrammes')">{{ $t('optimisation_de_projet') }}</span>
					</div>
					<div class="module_theme2" :class="{ active: activeSection === 'tabheatmapprix' }">
						<span v-if="app.livedata.volume_periode_1" class="module_titre" @click="scrollToElement2('tabheatmapprix')">{{ $t('prix_par_typo') }}</span>
					</div>
					<div class="module_theme2" :class="{ active: activeSection === 'tabsynoptique' }">
						<span v-if="app.livedata.volume_periode_1" class="module_titre" @click="scrollToElement2('tabsynoptique')">{{ $t('synoptique_programmes') }}</span>
					</div>
				</div>
				<div v-if="activeSection === 'tabsynoptiquers'" class="module_theme2" :class="{ active: activeSection === 'tabsynoptiquers' }">
					<span class="module_titre">{{$t('Insee')}}</span>
				</div>
				<div v-if="activeSection === 'tabAdresse'" class="module_theme2" :class="{ active: activeSection === 'tabAdresse' }">
					<span class="module_titre">{{$t('Qualité d\'adresse')}}</span>
				</div>
			</div>
			<div class="header" style="background: #f8f9fa !important;position: absolute; top: 66px; width:240px; height:60px;right: 0px;z-index:500">
				<div class="infinite-loader" v-if="app.loading"><div class="loader"><icon file="loader" :size="28" style="color:#6c21f9;" /></div></div>
				<div class="print-button" v-if="!app.loading&&app.livedata.volume_periode_1" @click="choix_report = !choix_report;"><icon file="printer" :size="28" /></div> <div class="print-button" v-else style="background-color: #ccc;"><icon file="printer" :size="28" /></div>
			</div>
			<div class="right-bar" v-if="app.view == 'report_B'" v-show="!app.loading_calc">
				<div class="right-bar-content" v-bar>
					<div class="" id="contentreport" ref="scrollable_content">
						
						<div class="tab-content section" ref="tabsecteur" id="tabsecteur">
							<div class="part" id="tabsecteurnom">
								<div class="part-title">{{ $t('secteurs') }}</div>
								<div class="part-content">
									<stat-box name="array-secteurs" />
								</div>
							</div>
						</div>
						
						<div style="height:5px"></div>
						<tab-programmes ref="tabprogrammes" id="tabprogrammes" class="section" v-if="app.livedata.volume_periode_1 && app.nbprogselect" v-observe-visibility="onVisibilityChange_tabprogrammes"/>
						<div style="height:5px"></div>
						<tab-heatmap-prix ref="tabheatmapprix" id="tabheatmapprix" class="section" v-if="app.livedata.volume_periode_1 && app.nbprogselect" v-observe-visibility="onVisibilityChange_tabheatmapprix"/>
						<div style="height:5px"></div>
						<tab-synoptique-b ref="tabsynoptique" id="tabsynoptique" class="section" v-if="app.livedata.volume_periode_1 && app.nbprogselect" v-observe-visibility="onVisibilityChange_tabsynoptique"/>
						<div style="height:5px"></div>
						<tab-insee ref="tabsynoptiquers" id="tabsynoptiquers" class="section" v-show="app.module_rs"  v-observe-visibility="onVisibilityChange_tabsynoptiquers"/>						
						<div style="height:5px"></div>
						<tab-adresse ref="tabAdresse" id="tabAdresse" class="section" v-if="app.mrk.lat && app.ModuleAdresse" v-observe-visibility="onVisibilityChange_tabAdresse"/>
						<div style="height:800px">&nbsp;</div>
					</div>
				</div>
			</div>
			<div class="left-bar" v-if="app.view == 'report_B'" v-show="!app.loading_calc"></div>
		</div>
	</transition>
</template>

<script>
import { mapGetters } from 'vuex'
import TabProgrammes from './pane-report/TabProgrammes'
import TabSynoptiqueB from './pane-report/TabSynoptiqueB'
import TabHeatmapPrix from './pane-report/TabHeatmapPrix'
import axios from 'axios'
import { ObserveVisibility  } from 'vue-observe-visibility'
import TabAdresse from './pane-report/TabAdresse'
import TabInsee from './pane-report/TabInsee'
import StatBox from './pane-report/report/StatBox'
import Button from 'primevue/button';

export default {
	name: 'PaneReport',

	data: function() {
		return {
			choix_module: {
				disabled: {
					neuf: false,
					rs: false,
					ancien: false,
					locatif: false,
					adresse: false
				},
				neuf: true,
				rs: true,
				ancien: true,
				locatif: true,
				adresse: true
			},
			choix_report: false,
			tableau_optimisation: false,
			activeSection2: null,
			activeSection_tabprogrammes: true,
			activeSection_tabheatmapprix: false,
			activeSection_tabsynoptique: false,
			activeSection_tabsynoptiquepc: false,
			activeSection_tabsynoptiquers: false,
			activeSection_tabAncien: false,
			activeSection_tabLocatif: false,
			activeSection_tabAdresse: false,
		}
	},

	computed: Object.assign(mapGetters([ 'app', 'report', 'selected_programs', 'user' ]), {
		activeSection:function(){
			let s = 'tabprogrammes'
			if (this.activeSection_tabprogrammes) {
				s = 'tabprogrammes'
			} else {
				if (this.activeSection_tabheatmapprix) {
					s = 'tabheatmapprix'
				} else {
					if (this.activeSection_tabsynoptique) {
						s = 'tabsynoptique'
					} else {
						if (this.activeSection_tabsynoptiquepc) {
							s = 'tabsynoptiquepc'
						} else {
							if (this.activeSection_tabsynoptiquers) {
								s = 'tabsynoptiquers'
							} else {
								if (this.activeSection_tabAncien) {
									s = 'tabAncien'
								} else {
									if (this.activeSection_tabLocatif) {
										s = 'tabLocatif'
									} else {
										if (this.activeSection_tabheatmapprix) {
											s = 'tabheatmapprix'
										} else {
											s = 'tabAdresse'
										}
									}
								}
							}
						}
					}
				}
			}
			
			return s
		},

		windowHeight() {
			return window.innerHeight;
		}

	}),

	watch: {
		
		'app.view': function(newValue) {
			if (newValue=='report_B') {
				this.choix_module.disabled.neuf = false
				this.choix_module.disabled.rs = false
				this.choix_module.disabled.ancien = false
				this.choix_module.disabled.locatif = false
				this.choix_module.disabled.adresse = false
				if (!this.app.module_rs) {
					this.choix_module.rs = false
					this.choix_module.disabled.rs = true
				}
				if (!(this.app.module_actif && this.app.module_cityscan)) {
					this.choix_module.locatif = false
					this.choix_module.disabled.locatif = true
				}
				if (!(this.app.mrk.lat && this.app.module_actif && this.app.ModuleAdresse && this.app.module_cityscan)) {
					this.choix_module.ancien = false
					this.choix_module.adresse = false
					this.choix_module.disabled.ancien = true
					this.choix_module.disabled.adresse = true
				}
			}
		},
	},

	directives: {
		'observe-visibility': ObserveVisibility
	},

	methods: {		
		onChangeModules: function(v) {
			this.choix_module[v] = !this.choix_module[v];
		},

		onVisibilityChange_tabAdresse(isVisible) {
			this.activeSection_tabAdresse = isVisible;
		},

		onVisibilityChange_tabprogrammes(isVisible) {
			this.activeSection_tabprogrammes = isVisible;
		},

		onVisibilityChange_tabheatmapprix(isVisible) {
			this.activeSection_tabheatmapprix = isVisible;
		},

		onVisibilityChange_tabsynoptique(isVisible) {
			this.activeSection_tabsynoptique = isVisible;
		},

		onVisibilityChange_tabsynoptiquepc(isVisible) {
			this.activeSection_tabsynoptiquepc = isVisible;
		},
		
		onVisibilityChange_tabAncien(isVisible) {
			this.activeSection_tabAncien = isVisible;
		},

		onVisibilityChange_tabLocatif(isVisible) {
			this.activeSection_tabLocatif = isVisible;
		},

		onVisibilityChange_tabsynoptiquers(isVisible) {
			this.activeSection_tabsynoptiquers = isVisible;
		},

		scrollToElement(elementId) {
			let that = this
			let $scroll = $(that.$refs.scrollable_content)
			let $program = $scroll.find('#' + elementId)
			let x = $program[0].offsetTop;
			let element = $program[0].offsetParent;
			while (element) {
				x += element.offsetTop
				try {
					x -= 30
					element = element.offsetParent;
				} catch (error) {
					break;
				}
			}
			$scroll.animate({ scrollTop: x }, 250)
		},

		scrollToElement2(elementId) {
			const element2 = document.getElementById(elementId);
			element2.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
		},

		handleScroll() {
			const observer = new IntersectionObserver(entries => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						let contentreport = document.getElementById("contentreport").scrollTop
						if (contentreport<=(document.getElementById("tabprogrammes").clientHeight-100)) {
							this.activeSection = 'tabprogrammes'
						} else {
							if (contentreport<=document.getElementById("tabprogrammes").clientHeight + (document.getElementById("tabheatmapprix").clientHeight-100)) {
								this.activeSection = 'tabheatmapprix'
							} else {
								if (contentreport<=document.getElementById("tabprogrammes").clientHeight + document.getElementById("tabheatmapprix").clientHeight + (document.getElementById("tabsynoptique").clientHeight-100)) {
									if (contentreport+(document.getElementById("contentreport").clientHeight/2)<=document.getElementById("tabprogrammes").clientHeight + document.getElementById("tabheatmapprix").clientHeight + document.getElementById("tabsynoptique").clientHeight ) {
										this.activeSection = 'tabsynoptique'
									} else this.activeSection = 'tabsynoptiquepc'
								} else {
									if (contentreport<=document.getElementById("tabprogrammes").clientHeight + document.getElementById("tabheatmapprix").clientHeight + document.getElementById("tabsynoptique").clientHeight + (document.getElementById("tabsynoptiquepc").clientHeight-100)) {
										this.activeSection = 'tabsynoptiquepc'
									} else {
										this.activeSection = 'tabsynoptiquers'
									}
								}
							}
						}
					}
				});

			});
			const elements = document.querySelectorAll('.section');
			elements.forEach(element => {
				observer.observe(element);
			});

		},

		export_html_report: function(){
			let zone = document.getElementById('report-programmes').innerHTML;
			zone = zone + document.getElementById('report-secteurs').innerHTML;
			zone = zone + document.getElementById('report-synoptique').innerHTML;
			zone = zone + document.getElementById('report-pc').innerHTML;
			// Ouverture du popup
			let fen = window.open("", "", "height=400, width=2024,toolbar=0, menubar=0, scrollbars=1, resizable=1,status=0, location=0, left=10, top=10")
			
			// style du popup
			fen.document.body.style.color = '#000000'
			fen.document.body.style.backgroundColor = '#FFFFFF'
			fen.document.body.style.padding = "0px"
			
			// Ajout des données a imprimer
			fen.document.title = 'Report'


			axios.get('https://www.myadequation.fr/EFOCUS/print_report.txt?' + _.now(), {})
			.then(response => {
			fen.document.body.innerHTML = '<style>' + response.data + '</style>'
			fen.document.body.innerHTML += " " + zone + " "
			
			// Impression du popup
			fen.window.print()
			
			//Fermeture du popup
			fen.window.close()
			return true
			}).catch(console.error)
		},

		export_html: function(){
			let zone = document.getElementById(data.divname).innerHTML;
			
			// Ouverture du popup
			let fen = window.open("", "", "height=1050, width=700,toolbar=0, menubar=0, scrollbars=1, resizable=1,status=0, location=0, left=10, top=10")
			
			// style du popup
			fen.document.body.style.color = '#000000'
			fen.document.body.style.backgroundColor = '#FFFFFF'
			fen.document.body.style.padding = "0px"
			
			// Ajout des données a imprimer
			fen.document.title = data.titre


			axios.get('https://www.myadequation.fr/EFOCUS/print_program.txt?' + _.now(), {})
			.then(response => {
			fen.document.body.innerHTML = '<style>' + response.data + '</style>'
			zone = zone.replace('height: 285px', '')
			fen.document.body.innerHTML += " " + zone + " "
			
			// Impression du popup
			fen.window.print()
			
			//Fermeture du popup
			fen.window.close()
			return true
			}).catch(console.error)
		},

		set_report: function() {
			this.$store.dispatch('set_report_dispo', { dispo: false })
		},

		click_tab: function(tab) {
			this.$store.dispatch('set_tab', { tab: tab })
			this.$router.push({ name: tab}).catch(()=>{});
		},

		toggle_report: function() {
			let view = 'report_B'
			if (this.app.view == 'report_B') view = 'list'
			this.set_view(view)
		},

		set_back: function() {
			this.$store.dispatch('set_view', { view: this.app.source_view })
		},

		set_view: function(view) {
			this.$store.dispatch('set_view', { view: view })
		},

		set_html: function() {

		},

		get_pdf: function() {
			this.choix_report = false
			this.tableau_optimisation = []
			let elem = document.createElement('textarea')
			let price_min = ""
			let price_moy = ""
			let price_max = ""
			for (let i=1; i<13;i++) {
				if (document.getElementById('opt_lib_' + i) && document.getElementById('opt_si_' + i)) {
					elem.innerHTML = document.getElementById('opt_pummin_' + i).innerHTML
					price_min = elem.value
					elem.innerHTML = document.getElementById('opt_pummoy_' + i).innerHTML
					price_moy = elem.value
					elem.innerHTML = document.getElementById('opt_pummax_' + i).innerHTML
					price_max = elem.value
					this.tableau_optimisation.push(
						{
							libelle : document.getElementById('opt_lib_' + i).innerHTML,
							stock_initial: document.getElementById('opt_si_' + i).innerHTML,
							offre_total: document.getElementById('opt_offre_' + i).innerHTML,
							ventes_totales: document.getElementById('opt_ventes_' + i).innerHTML,
							rythme: document.getElementById('opt_rythme_' + i).innerHTML,
							surface_min: document.getElementById('opt_surfmin_' + i).innerHTML,
							surface_moy: document.getElementById('opt_surfmoy_' + i).innerHTML,
							surface_max: document.getElementById('opt_surfmax_' + i).innerHTML,
							pum_min: price_min,
							pum_moy: price_moy,
							pum_max: price_max,
							stock_initial_nb: document.getElementById('opt_si_nb_' + i).innerHTML,
							offre_total_nb: document.getElementById('opt_offre_nb_' + i).innerHTML,
							ventes_totales_nb: document.getElementById('opt_ventes_nb_' + i).innerHTML,
							rythme_mois: document.getElementById('opt_rythme_mois_' + i).innerHTML,
							rythme_vtemois: document.getElementById('opt_rythme_vtemois_' + i).innerHTML,
						}
					)
				}
			}

			let modules = ''
			if (this.choix_module.neuf) modules = modules + '1,'
			if (this.choix_module.rs) modules = modules + '2,'
			if (this.choix_module.ancien) modules = modules + '3,'
			if (this.choix_module.locatif) modules = modules + '4,'
			if (this.choix_module.adresse) modules = modules + '5,'
			this.$store.dispatch('get_report_pdf_b', { tableau: this.tableau_optimisation, entree: this.app.optimisation.entree, destination: this.app.optimisation.destination, tva: this.app.optimisation.financement, prix: this.app.optimisation.prix, modules: modules })
		},

		get_pdf3: function() {
			this.tableau_optimisation = []
			let elem = document.createElement('textarea')
			let price_min = ""
			let price_moy = ""
			let price_max = ""
			for (let i=1; i<13;i++) {
				if (document.getElementById('opt_lib_' + i)) {
					elem.innerHTML = document.getElementById('opt_pummin_' + i).innerHTML
					price_min = elem.value
					elem.innerHTML = document.getElementById('opt_pummoy_' + i).innerHTML
					price_moy = elem.value
					elem.innerHTML = document.getElementById('opt_pummax_' + i).innerHTML
					price_max = elem.value
					this.tableau_optimisation.push(
						{
							libelle : document.getElementById('opt_lib_' + i).innerHTML,
							stock_initial: document.getElementById('opt_si_' + i).innerHTML,
							offre_total: document.getElementById('opt_offre_' + i).innerHTML,
							ventes_totales: document.getElementById('opt_ventes_' + i).innerHTML,
							rythme: document.getElementById('opt_rythme_' + i).innerHTML,
							surface_min: document.getElementById('opt_surfmin_' + i).innerHTML,
							surface_moy: document.getElementById('opt_surfmoy_' + i).innerHTML,
							surface_max: document.getElementById('opt_surfmax_' + i).innerHTML,
							pum_min: price_min,
							pum_moy: price_moy,
							pum_max: price_max,
							stock_initial_nb: document.getElementById('opt_si_nb_' + i).innerHTML,
							offre_total_nb: document.getElementById('opt_offre_nb_' + i).innerHTML,
							ventes_totales_nb: document.getElementById('opt_ventes_nb_' + i).innerHTML,
							rythme_mois: document.getElementById('opt_rythme_mois_' + i).innerHTML,
							rythme_vtemois: document.getElementById('opt_rythme_vtemois_' + i).innerHTML,
						}
					)
				}
			}

			this.$store.dispatch('get_report_pdf3', { tableau: this.tableau_optimisation })
		},

		get_pdf2: function() {
			let zone = document.getElementById('report-programmes').innerHTML;
			zone = zone + document.getElementById('report-secteurs').innerHTML;
			zone = zone + document.getElementById('report-synoptique').innerHTML;
			zone = zone + document.getElementById('report-pc').innerHTML;
			let that = this
			axios.get('https://www.myadequation.fr/EFOCUS/print_report.txt?' + _.now(), {})
			.then(response => {
				zone = '<html><head><style>' + response.data + '</style></head><body>' + zone + '</body></html>'
				that.$store.dispatch('get_report_pdf2', { html: zone })
			}).catch(console.error)

		},
		
	},

	mounted() {		
	},

	components: { TabProgrammes, TabSynoptiqueB, TabHeatmapPrix, TabAdresse, TabInsee, StatBox, Button }
}
</script>

<style lang="stylus" scoped>
@import '../assets/css/app'


.pane-report
	position fixed
	left 100%
	top 60px
	bottom 0
	height calc(100% - 59px)
	width 100%
	background-color #333
	color #ccc
	transition 0.5s easeOutQuart
	z-index 500
	&.vi
		width calc(100% - 300px)
		.module_ret
			visibility visible
		.back-button
			visibility visible
		.right-bar
			visibility visible
	&.cart
		transform translateX(-300px)
	&.report
		transform translateX(-100%)
	&.slide-enter, &.slide-leave-to
		transform translateX(0)
	.infinite-loader
		position absolute
		right 188px
		top 18px
		.loader
			display inline-block
			background main_color
			border-radius 100%
			color #fff
			.icon
				display block
				animation rotate 1.5s infinite linear
	.header
		background white
		border-bottom 1px solid #ccc
		height 66px
		color #000
		.back-button
			text-align center
			height 100%
			width 60px
			border-left 1px solid #ccc
			line-height 60px
			position absolute
			left 0px
			top 0px
			cursor pointer
			transition 0.25s easeOutQuart
			&:hover
				background-color primaryA100
				color white
		.print-button
			text-align center
			position absolute
			right 0px
			top 0px
			height 100%
			width 60px
			border-left 1px solid #ccc
			line-height 60px
			cursor pointer
			transition 0.25s easeOutQuart
			&:hover
				background-color primaryA100
				color white
		.print-button-disabled
			text-align center
			position absolute
			right 0px
			top 0px
			height 100%
			width 60px
			border-left 1px solid #ccc
			line-height 60px
			transition 0.25s easeOutQuart
			background-color #ccc;
		.print-button2
			text-align center
			height 100%
			width 60px
			border-left 1px solid #ccc
			line-height 60px
			position absolute
			right 120px
			top 0px
			cursor pointer
			transition 0.25s easeOutQuart
			&:hover
				background-color primaryA100
				color white
		.print-button3
			text-align center
			position absolute
			right 180px
			top 0px
			height 100%
			width 60px
			border-left 1px solid #ccc
			line-height 60px
			cursor pointer
			transition 0.25s easeOutQuart
			&:hover
				background-color primaryA100
				color white
		.help-button
			text-align center
			height 100%
			width 60px
			border-left 1px solid #ccc
			line-height 60px
			position absolute
			right 60px
			top 0px
			cursor pointer
			transition 0.25s easeOutQuart
			&:hover
				background-color primaryA100
				color white
	.tabs2
		color secondary
		background white
		border-left 1px solid hsl(0deg 0% 86%)
		&:after
			content ''
			display block
			clear both
		.tab
			float left
			margin 0 0px 0 0
			height 60px
			width 220px
			display flex
			align-items center
			justify-content center
			flex-direction column
			opacity 1
			font-size 12px
			font-weight 400
			border-bottom 4px solid transparent
			text-align center
			text-transform uppercase
			cursor pointer
			color #a1a5b8
			border-right 1px solid hsl(0deg 0% 86%)
			&:hover
				color #666
			&.active
				opacity 2
				border-bottom-color var(--primary)
				color var(--primary)
			.icon
				display block
				margin 0 0 2px 0
	.left-bar
		height calc(100% - 96px)
		background light
		width 0px
		color #333
		.left-bar-content
			height 100%
			.content
				height 100%
				
	.right-bar
		float right
		height calc(100% - 96px)
		background light
		width 100%
		color #333
		.right-bar-content
			height 100%
			.content
				height 100%

		.scroll-dots
			position absolute
			left -40px
			top 24px
			width 32px
			background alpha(green, 50%)
			border-radius radius
			z-index 2
			transition 0.25s easeOutQuart
			&:hover
				background alpha(green, 75%)
			.dot
				display block
				width 8px
				height 8px
				margin 12px
				background #fff
				opacity 0.25
				border-radius 100%
				transition 0.25s easeOutQuart
				cursor pointer
				&:hover, &.active
					opacity 1
.download_div_big					
	position absolute
	height 100%
	width 100%
	z-index 998
	left 0
	top 0
	text-align center
	background #666
	opacity 0.5
.download_div
	position absolute
	height 96px
	width 96px
	z-index 999
	left 50%
	top 50%
	text-align center
	background #FAFAFA
	border 1px solid rgba(0, 0, 0, 0.6)
	box-sizing border-box
	border-radius 20px
.tab-content
	padding 24px 32px
	.part
		margin 0 0 40px 0
		.part-title
			margin 0 0 8px 0
			line-height 32px
			font-weight 600
			text-transform uppercase
			font-size 16px

#contentreport
	min-height calc(100% + 10px)


.toreport
	position absolute
	right 10px
	top 12px
	height 60px
.buttonv
	border 0
	border-radius 0
	background primaryA400
	border-radius 18px
	font-style normal
	font-size 12px
	text-align center
	letter-spacing 0.75px
	text-transform uppercase
	color #FFFFFF
	width 215px
	height 36px
	cursor pointer
	&:hover
		background secondary
	> a
		color #FFFFFF !important
.top-bar
	height 60px
	background white
	width 100%
	color #333
	.top-bar-content
		width 100%
.contentheader
	width 100%
	display flex
	

.moduletop
	display block
	width 20%
	max-width 220px
	height 59px
	line-height 60px
	padding-left 10px
	vertical-align middle
	background-color #ffffff
	border-right 1px solid #cccccc
	cursor pointer
	text-align left
	&:hover
		background #f9f9f9
		border-bottom 4px solid hsl(153deg 48% 49%)
		background rgba(28, 142, 186, 0.1);
.active


.highcharts-credits
	visibility hidden !important
	display none !important

.dropdown
	color #333
	padding 10px !important
	position absolute
	z-index 999
	top 130px
	right 5px
	background-color #fff
	border-radius 4px
	box-shadow none
	padding-bottom 0.5rem
	border 1px solid #ccc
	padding-top 0
	overflow hidden
	table
		tr
			td
				padding 5px

.company-dashboard .company-header {
	display: flex;
	padding: 20px;
	background: var(--white);
	border: 1px solid var(--fade-grey-dark-3);
	border-radius: 4px;
	margin-bottom: 0.2rem;
}
.company-dashboard .company-header .header-item {
	width: 50%;
	border-right: 1px solid var(--fade-grey-dark-3);
}
.company-dashboard .company-header .header-item:last-child {
	border-right: none;
}
.company-dashboard .company-header .header-item .item-inner {
	text-align: center;
}
.company-dashboard .company-header .header-item .item-inner .lnil, .company-dashboard .company-header .header-item .item-inner .lnir {
	font-size: 1.8rem;
	margin-bottom: 6px;
	color: var(--primary);
}

.lnil {
	display: inline-block;
	font: normal normal normal 1em/1 'LineIconsPro Light';
	speak: none;
	text-transform: none;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
.company-dashboard .company-header .header-item .item-inner span {
	display: block;
	font-family: var(--font), sans-serif;
	font-weight: 600;
	font-size: 1.6rem;
	color: var(--dark-text);
}
.company-dashboard .company-header .header-item .item-inner p {
	font-family: var(--font-alt), sans-serif;
	font-size: 0.85rem;
}


.r {
	font-family: var(--font-alt), sans-serif !important;
	font-size: 0.95rem !important;
	font-family: var(--font), sans-serif !important;
	font-weight: 300 !important;
	color: var(--light-text) !important;
	display: initial !important;
}


.company-dashboard .dashboard-card.is-base-chart {
	padding: 0;
	display: flex;
	flex-direction: column;
}

.company-dashboard .dashboard-card {
	flex: 1;
	display: inline-block;
	width: 100%;
	padding: 20px;
	background-color: var(--white);
	border-radius: 6px;
	border: 1px solid var(--fade-grey-dark-3);
	transition: all 0.3s;
	height: 100%;
}
.company-dashboard .dashboard-card.is-base-chart .content-box {
	padding: 30px;
}
.company-dashboard .dashboard-card.is-base-chart .chart-container {
	margin-top: auto;
}
.company-dashboard .dashboard-card.is-base-chart .content-box .revenue-stats {
	display: flex;
	padding-bottom: 20px;
	border-bottom: 1px solid var(--fade-grey-dark-3);
}
.company-dashboard .dashboard-card.is-base-chart .content-box .revenue-stats .revenue-stat {
	margin-right: 30px;
	font-family: var(--font), sans-serif;
}
.company-dashboard .dashboard-card.is-base-chart .content-box .revenue-stats .revenue-stat span:first-child {
	text-transform: uppercase;
	font-family: var(--font-alt), sans-serif;
	font-size: 0.75rem;
	color: var(--light-text);
}

.company-dashboard .dashboard-card.is-base-chart .content-box .revenue-stats .revenue-stat span {
	display: block;
}
.company-dashboard .dashboard-card.is-base-chart .content-box .revenue-stats .revenue-stat span.current {
	color: var(--primary);
}

.company-dashboard .dashboard-card.is-base-chart .content-box .revenue-stats .revenue-stat span:nth-child(2) {
	color: var(--dark-text);
	font-size: 1.6rem;
	font-weight: 600;
}
@keyframes rotate
	from
		transform rotate(0deg)
	to
		transform rotate(359deg)

</style>
